import {Fragment} from "react";
import {FiCheck, FiCircle} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {ContentHeaderButton} from "@/marketingPages/components/contentheaderbutton/ContentHeaderButton.tsx";

import styles from "./CTABlock.module.scss";

interface CTABlockProps {
  title: string;
  subtitle?: string;
  topBar?: boolean;
  bottomBar?: boolean;
}

const TOP_BAR = ["Website Monitoring Service", "Uptime Monitoring", "API Monitoring", "Page Speed Test", "Status Page"];
const BOTTOM_BAR = [
  "14-day free trial",
  "No credit card required",
  "24/7/365 real-time support",
  "Resilient & secure platform",
];

export const CTABlock = ({title, subtitle, topBar, bottomBar}: CTABlockProps) => {
  return (
    <div className={`${styles.ctaBlock} d-flex flex-column align-items-center`}>
      {topBar && (
        <div className={styles.topBar}>
          {TOP_BAR.map((item, index) => (
            <Fragment key={`cta-top-bar-${index}`}>
              <div className="marketingTextBody pulse-color-gray-700 text-nowrap">{item}</div>
              {index < TOP_BAR.length - 1 && <Icon icon={FiCircle} className={styles.topBarIcon} />}
            </Fragment>
          ))}
        </div>
      )}
      <div>
        <h2 className="marketingTextH2Bold text-center">{title}</h2>
        {subtitle && <div className="marketingTextBody mt-3">{subtitle}</div>}
      </div>
      <ContentHeaderButton />
      {bottomBar && (
        <div className={styles.bottomBar}>
          {BOTTOM_BAR.map((item, index) => (
            <div key={`cta-bottom-bar-${index}`}>
              <div className="marketingTextBody pulse-color-gray-600">
                <Icon icon={FiCheck} className="pulse-color-green-500" display="inline" />
                {item}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
